import {
    Injectable
} from '@angular/core';
@Injectable()
export class ModalScreensService {
    private modalScreens: {
        [name: string]: any
    } = {};
    async getModalScreen(screenName: string) {
        if (!this.modalScreens[screenName]) {
            let modalImport;
            switch (screenName) {
                case "InitialSetup":
                    modalImport = await
                    import (`../../InitialSetup/InitialSetup`);
                    break;
                case "CropImage":
                    modalImport = await
                    import (`../../CropImage/CropImage`);
                    break;
                case "Note":
                    modalImport = await
                    import (`../../Note/Note`);
                    break;
            }
            if (modalImport) {
                this.modalScreens[screenName] = modalImport[screenName];
            }
        }
        return this.modalScreens[screenName]
    }
};